const urlRegex =
  /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]*)?$/;

function isValidUrl(url: string) {
  return urlRegex.test(url);
}

export default isValidUrl;
